import { getFullErrorState } from '../general/selectors';

import { ListingsBenchmarkTopListingsActionTypes } from './constants';
import { getTopListingsBenchmarkCacheDictionaryKey } from './selectors';

export const topListings = (state, action) => {
  switch (action.type) {
    case ListingsBenchmarkTopListingsActionTypes.GET_TOP_LISTINGS_DATA_SUCCESS:
      return {
        ...state,
        // caching to eliminate unnecessary ajax calls
        [getTopListingsBenchmarkCacheDictionaryKey(
          state.selectedTimeDivisionFilter,
          state.selectedYear,
          state.selectedMonth,
          action.currentLevel,
          action.currentDealerId,
        )]: action.result,
      };
    case ListingsBenchmarkTopListingsActionTypes.GET_TOP_LISTINGS_DATA_ERROR:
      return getFullErrorState(state, action);
    case ListingsBenchmarkTopListingsActionTypes.SET_ACTIVE_TOP_LISTINGS_CATEGORY:
      return {
        ...state,
        selectedTopListingsCategory: action.category,
      };
    default:
      return state;
  }
};
